exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nav-item h1[data-v-61dd7a3d] {\n  margin-bottom: 0rem;\n}\na.nav-link.router-link-exact-active.router-link-active[data-v-61dd7a3d] {\n  color: #ff8e05;\n}\n", ""]);

